module.exports = __webpack_public_path__ + "1a642aa6a54c36d608deafd5d5d5eee5.svg";